export const generateSeriesId = (series) => {
    // these props are the same in main and respective compare series
    return `${series.stack}_${series.name}_${series.legendIndex}`;
};
